<template>
  <div class="navbar-container">
    <div class="menu">
      <span
        v-for="item in menu"
        :key="item.label"
        :class="{ active: menu_active === item.label }"
        @click="menuClick(item.label)"
        >{{ item.label }}</span
      >
    </div>
    <div class="sort">
      <span>排序</span>
      <span
        v-for="item in sort_c"
        :key="item.label"
        :class="{ active: sort_active === item.label }"
        @click="sortClick(item.label)"
        >{{ item.label }}</span
      >
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      menu_active: '店长素材',
      menu: [
        { label: '店长素材' },
        { label: '官方公告' },
        { label: '新人成长' },
      ],
      sort_active: '时间',
      sort: [{ label: '时间' }, { label: '热度' }],
    }
  },
  computed: {
    sort_c() {
      if (this.menu_active === '店长素材') {
        return [{ label: '时间' }, { label: '热度' }]
      }
      return [{ label: '时间' }]
    }
  },
  methods: {
    menuClick(val) {
      if (this.menu_active !== val) {
        this.menu_active = val
        this.sort_active = '时间'
        this.$emit('menuChange')
      }
    },
    sortClick(val) {
      this.sort_active = val
      this.$emit('search')
    },
  },
}
</script>

<style lang="less" scoped>
.navbar-container {
  text-align: left;
  padding: 16px 20px 14px;
  .menu {
    span {
      display: inline-block;
      padding: 10px 0;
      font-size: 28px;
      font-weight: 400;
      color: #333333;
      line-height: 34px;
      margin-right: 40px;
      &.active {
        font-weight: 600;
        color: #e82035;
      }
    }
  }
  .sort {
    padding-top: 10px;
    span {
      display: inline-block;
      padding: 10px 0;
      font-size: 24px;
      font-weight: 400;
      color: #3a3a3a;
      line-height: 24px;
      margin-right: 40px;
      &.active {
        font-weight: 600;
        color: #e82035;
      }
      &:nth-of-type(1) {
        color: #aeaeae;
      }
    }
  }
}
</style>